import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import InvalidForm  from 'src/components/InvalidForm'
import InputField   from 'src/components/InputField'
import CheckBox     from 'src/components/CheckBox'
import Switcher     from '../express-fundraiser/Switcher'

import csrfHeaders  from 'src/utils/csrfHeaders'

const SignIn = ({ loading, setLoading, signInUrl, toggleSignIn, omni }) => {
  const [ email, setEmail ] = useState('')
  const [ password, setPassword ] = useState('')
  const [ remember_me, setRememberMe ] = useState(false)
  const [ errors, setErrors ] = useState({})

  const handleSubmit = async e => {
    e.preventDefault()
    if (loading) return

    setLoading(true)
    try {
      const response = await fetch(signInUrl, {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify({ user: { email, password, remember_me } }),
      })

      if (response.ok)
        location.reload()
      else {
        const json = await response.json()
        setErrors(json.errors)
      }
    } catch (error) {
      setErrors({ base: [ 'Something went wrong. Please try again.' ] })
    } finally {
      setLoading(false)
    }
  }

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Switcher omni={omni} toggleSignIn={toggleSignIn}>
        <FontAwesomeIcon icon="user-plus" className="me-1" />
        {' Sign Up with Email'}
      </Switcher>

      <h2 className="text-center">Sign In</h2>

      <InvalidForm>{errors?.base?.[0]}</InvalidForm>

      <InputField
        required
        requiredLabel={false}
        id="email"
        type="email"
        label="Email"
        autoComplete="username"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />

      <InputField
        required
        requiredLabel={false}
        id="current-password"
        type="password"
        label="Password"
        autoComplete="current-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />

      <div className="d-flex justify-content-between">
        <CheckBox
          id="remember_me"
          label="Stay signed in"
          checked={remember_me}
          onChange={e => setRememberMe(e.target.checked)}
        />
        <div className="pe-1">
          <a
            href={`/accounts/password/reset?user%5Bemail%5D=${encodeURIComponent(email)}`}
            target="_blank"
          >
            Forgot your password?
          </a>
        </div>
      </div>

      <div className="text-center">
        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </div>
    </form>
  )
}

export default SignIn
